import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { CdsButtonConfig } from '@cds/ng-core/button';
import { MatDialogRef } from '@cds/ng-web-components/popup';
import { Subscription } from 'rxjs';
import { LanguageChangeService } from 'src/app/shared/language-change.service';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-user-exit-editmode-pop',
  templateUrl: './user-exit-editmode-pop.component.html',
  styleUrls: ['./user-exit-editmode-pop.component.scss'],
  imports: [CdsButtonModule, CdsLanguageModule],
})
export class UserExitEditmodePopComponent implements OnInit, OnDestroy {
  languageChangeService = inject(LanguageChangeService);
  private dialogRef = inject<MatDialogRef<UserExitEditmodePopComponent>>(MatDialogRef);

  language = 'EN';
  lanSubscription?: Subscription;

  agreeButtonConfig: CdsButtonConfig = {
    label: this.language === 'EN' ? 'Confirm and Continue' : '確認繼續',
    size: 'sm',
    style: 'primary',
    disabled: false,
  };

  disagreeButtonConfig: CdsButtonConfig = {
    label: this.language === 'EN' ? 'Cancel' : '取消',
    size: 'sm',
    style: 'primary',
    disabled: false,
  };

  ngOnInit(): void {
    this.lanSubscription = this.languageChangeService.lanSubject.subscribe(lan => {
      this.language = lan === 'en' ? 'EN' : 'TC';
    });
  }

  ngOnDestroy(): void {
    this.lanSubscription?.unsubscribe();
  }

  agree() {
    this.dialogRef.close({ agree: true });
  }

  disagree() {
    this.dialogRef.close({ agree: false });
  }
}
